import React from 'react'
import { Select } from 'components/select'
import { FilterOptions } from './filterOptions'
import { LogicOptions } from './logicOptions'

export const LookupFilter = ({ localize, column, update, classes, availableColumns }) => {
  const handleOnChange = React.useCallback((value) => update({ value }), [update])
  const api = availableColumns.find(x => x.id === column.id).api
  return (
    <div>
      <FilterOptions localize={localize} classes={classes} column={column} update={update}  />
      <Select
        isMulti
        value={column.value}
        onChange={handleOnChange}
        dataSource={api.get}
        />
      <LogicOptions localize={localize} classes={classes} column={column} update={update} />
    </div>
  )
}